import React from 'react';
import { APP_CONTAINER_ROUTES } from '@/navigators/routes';
import { AppContainerStackParams } from '@/navigators/types';
import { OrderDetailComponent } from './order-detail-component';
import { StackScreenProps } from '@react-navigation/stack';
import { useLayoutContext } from '@/contexts/layout-context';

type Props = StackScreenProps<
  AppContainerStackParams,
  APP_CONTAINER_ROUTES.OrderDetail
>;

export const OrderDetailScreen: React.FC<Props> = ({ route }) => {
  const { orderUUID } = route.params;
  const { isSmallLayout } = useLayoutContext();

  return (
    <OrderDetailComponent
      invoiceButtonPosition={isSmallLayout ? 'bottom' : 'top'}
      orderUUID={orderUUID}
      showBackButton
    />
  );
};
